module.exports = __webpack_public_path__ + "img/avatar8.607655f2.jpg";